import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';

@Component({
  selector: 'app-abchest',
  templateUrl: './abchest.component.html',
  styleUrls: ['./abchest.component.scss']
})
export class AbchestComponent implements OnInit {

  constructor(private titleService: Title, private angulartics2: Angulartics2, private meta: Meta) {
    this.titleService.setTitle('ABChest - jocul');
    this.meta.updateTag({ property: 'og:title', content: 'ABChest - jocul' });
    this.meta.updateTag({
      property: 'og:description',
      content: 'Joc pentru preșcolari de învățare de litere și cifre în română și engleză'
    });
    this.meta.updateTag({
      property: 'twitter:card',
      content: 'Joc pentru preșcolari de învățare de litere și cifre în română și engleză'
    });
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/online-games/abchest/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/logo.jpg' });
    this.angulartics2.eventTrack.next({
      action: 'ABChest - jocul',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit(): void {
  }

}
